import { makeStyles } from '@material-ui/core';

export const useRegistrationsStyles = makeStyles(theme => ({
  titleBox: {
    borderBottomWidth: '1px',
    borderBottomColor: theme.palette.grey[600],
    borderBottomStyle: 'solid',
  },
  titleText: {
    color: theme.palette.grey[600],
  },
}));
export const useRolesAndCertsStyles = makeStyles(theme => ({
  titleBox: {
    borderBottomWidth: '1px',
    borderBottomColor: theme.palette.grey[600],
    borderBottomStyle: 'solid',
  },
  titleText: {
    color: theme.palette.grey[600],
  },
  selectRole: {
    marginTop: '10px',
    marginBottom: '10px',
    width: '200px',
  },
}));
export const useEvaluationsStyles = makeStyles(theme => ({
  titleBox: {
    borderBottomWidth: '1px',
    borderBottomColor: theme.palette.grey[600],
    borderBottomStyle: 'solid',
  },
  titleText: {
    color: theme.palette.grey[600],
  },
}));
